import { Seite, SeiteFactory } from '@ebeihilfe/einreichung-old';

export class WebSeiteFactory extends SeiteFactory {
  public CreateSeite(): Seite {
    return new Seite(this.converterService, this.einreichungsApi, this.endToEndEncrypter);
  }
}
